import { useNavigate } from "react-router-dom";
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { useMemo, useState } from "react";
import ParcialRCS from "./parcialRCS";
import { RCSService } from "../../../services/RCSService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AlertService } from "../../../services/Alert";
import Button from "../../../components/form-controls/Button";
import { useTranslation } from "react-i18next";
function AddTemplatePageRCS() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const navigate = useNavigate();

    const [stepValid, setstepValid] = useState(false)
    const [formTemplate, FormTemplate] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const isValid = useMemo(() => {


        return stepValid;
    }, [stepValid])

    const header = useMemo(() => {
        if (!formTemplate || !formTemplate.header || formTemplate.header.format.value === 'none') {
            return null;
        }

        if (formTemplate.header.format.value === 'text') {
            return {
                type: 'HEADER',
                format: 'TEXT',
                text: formTemplate.header.text,
            };
        }
        if (formTemplate.header.format.value === 'media' && formTemplate.header.content.value === 'image') {
            return {
                type: 'HEADER',
                format: 'IMAGE',
                // example: {
                //     header_handle: [formTemplate.header.example.header_handle]
                // },
                url: formTemplate.header.url,
                image: formTemplate.header.url
            };
        }
        if (formTemplate.header.format.value === 'media' && formTemplate.header.content.value === 'video') {
            return {
                type: 'HEADER',
                format: 'VIDEO',
                // example: {
                //     header_handle: [formTemplate.header.example.header_handle]
                // },
                url: formTemplate.header.url,
                video: formTemplate.header.url,
            };
        }
        if (formTemplate.header.format.value === 'media' && formTemplate.header.content.value === 'document') {
            return {
                type: 'HEADER',
                format: 'DOCUMENT',
                // example: {
                //     header_handle: [formTemplate.header.example.header_handle]
                // },
                url: formTemplate.header.url,
                document: formTemplate.header.url,
            };
        }

        return null;
    }, [formTemplate])

    const body = useMemo(() => {
        if (!formTemplate || !formTemplate.body) {
            return null;
        }

        let body_vars = []
        formTemplate.body.example.body_text.map(v => body_vars[v.key - 1] = v.value);

        let body = {
            ...formTemplate.body
        }

        if (body_vars.length) {
            body.example = {
                body_text: [body_vars]
            }
        } else {
            delete body.example
        }

        return body;

    }, [formTemplate])


    const buttons = useMemo(() => {

        if (!formTemplate || !formTemplate.buttons || formTemplate.buttons.buttons.length === 0) {
            return null;
        }


        let buttons = []

        for (const btn of formTemplate.buttons.buttons) {
            if (btn.type === 'QUICK_REPLY') {
                buttons.push({
                    type: 'QUICK_REPLY',
                    text: btn.text
                })
            }
            if (btn.type === 'URL' && btn.style === 'static') {
                buttons.push({
                    type: 'URL',
                    text: btn.text,
                    url: btn.url
                })
            }
            if (btn.type === 'URL' && btn.style === 'dynamic') {
                buttons.push({
                    type: 'URL',
                    text: btn.text,
                    url: `${btn.url}{{1}}`,
                    example: [btn.example]
                })
            }
            if (btn.type === 'QUICK_REPLY_DISABLE_MKT') {
                buttons.push({
                    type: 'QUICK_REPLY',
                    text: btn.text
                })
            }
        }

        return {
            type: 'BUTTONS',
            buttons: buttons
        }

    }, [formTemplate])

    const save = async () => {
        try {
            setIsSubmitting(true)

            const btn = formTemplate.buttons.buttons.find(b => b.type === 'QUICK_REPLY_DISABLE_MKT');
            let data = {
                account_id: account.id,
                name: formTemplate.name,
                app: 'RCS',
                components: [],
                btn_blacklist: btn ? btn.text : null
            }

            if (header) {
                data.components.push(header)
            }

            if (body) {
                data.components.push(body)
            }

            if (buttons) {
                data.components.push(buttons)
            }

            await RCSService.saveTemplate(data)

            AlertService.toastSuccess('Se guardó correctamente la plantilla')

            navigate('/channels/templatesRCS')

        } catch (error) {
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la plantilla, intenta más tarde.')
        } finally {
            setIsSubmitting(false)
        }
    }


    return (
        <>
            <Header />
            <Aside />
            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.platform-title")}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" > {t("platform.channels.channels-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">RCS</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">
                                <button title="k" type="button" className="btn btn-soft-primary btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>
                                <h2 className="page-header-title m-0 me-3 text-dark">{t("platform.channels.templates.add-template")}</h2>
                            </div>
                            <div className="col-sm-auto">
                                <><Button className="btn btn-primary" isLoading={isSubmitting} disabled={!isValid} onClick={save}>{t("platform.channels.templates.btn-save")}</Button>
                                </>
                            </div>
                        </div>
                    </div>
                    <ParcialRCS onChange={(form: any) => FormTemplate(form)} isValidForm={setstepValid} />
                    <div className="row">
                        <div className="col">
                            <div className="d-flex my-5">
                                <div className="ms-auto"> <>  <Button className="btn btn-primary" isLoading={isSubmitting} disabled={!isValid} onClick={save}>{t("platform.channels.templates.btn-save")}</Button>
                                </>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </main>
        </>
    )
}
export default AddTemplatePageRCS